export enum ChannelFilter {
  ALL = 'ALL',
  WEB = 'WEB',
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
  BROWSER = 'BROWSER',
  SMS = 'SMS',
}
